<script setup lang="ts">
import { useI18n } from "vue-i18n";

import { useCardStore } from "@/store/card";
import type { UpperLevelLinksSelection } from "@/store/search/searchMenu";

defineProps<{ selection: UpperLevelLinksSelection }>();

const { t } = useI18n();

function getTooltipText(selection: UpperLevelLinksSelection) {
  switch (selection.type) {
    case "linked":
      return t("label.linkedOnly");
    case "unlinked":
      return t("label.unlinkedOnly");
    case "sticky": {
      const id = selection.stickyId;
      const feature = useCardStore().cards[id];
      return feature?.text || "";
    }
    default:
      return "";
  }
}
</script>

<template>
  <div>{{ $t("label.upperLevelLinks") }}</div>
  <div v-if="getTooltipText(selection)" class="shortcut">{{ getTooltipText(selection) }}</div>
</template>
